import { usePageTitle } from "../../../../../shared/hooks/usePageTitle";
import { PageHead, PageShell } from "../../components/PageShell";
import { useTranslation } from "../../i18n/useTranslation";

// book.uselura.com/ — the bare root, which is NOT a booking link.
//
// A booking link always carries a slug. Someone here either trimmed the URL or
// typed the host directly, so this explains where they are and sends them on
// rather than pretending to be a product surface.
function Landing() {
  const { t } = useTranslation();
  usePageTitle(t("landing.title"));

  return (
    <PageShell>
        <PageHead title={t("landing.title")} />
        <p className="b-p">
          {t("landing.body")}
        </p>
        {t("landing.hint") ? <p className="b-hint">{t("landing.hint")}</p> : null}
    </PageShell>
  );
}

export default Landing;
